import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type TabType = 'sign' | 'verify';

@Injectable({
  providedIn: 'root'
})
export class TabStateService {
  private activeTab$ = new BehaviorSubject<TabType>('sign');

  /**
   * Observable del tab activo
   */
  get activeTab(): Observable<TabType> {
    return this.activeTab$.asObservable();
  }

  /**
   * Obtiene el tab activo actual
   */
  get currentTab(): TabType {
    return this.activeTab$.value;
  }

  /**
   * Establece el tab activo
   */
  setActiveTab(tab: TabType): void {
    this.activeTab$.next(tab);
  }
}

